export default {
  codigo: {
    value: null,
    required: false,
    state: null
  },
  nome: {
    value: null,
    required: true,
    state: null
  },
  entidade: {
    value: null,
    options: [
      { value: 1, label: 'Contas Receber' },
      { value: 2, label: 'PO' }
    ],
    required: true,
    state: null
  },
  etapaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  empresaID: {
    value: null
  },
  pertenceFatBasico: {
    value: false,
    required: true,
    state: null
  },
  itens: {
    value: []
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/dictionaries/dictionary-form.js